// reducers.js
import { UPDATE_DECK_UPDATE } from './actions';

const initialState = {
    data: {},
};

const UpdateDeckReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DECK_UPDATE:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default UpdateDeckReducer;
